<template>
  <div>
    <vx-card>
      <div class="flex justify-between items-center mb-4">
        <h2>HaioFlash Addons</h2>
        <vs-button color="primary" @click="showDialog = true">
          <feather-icon icon="PlusIcon" class="mr-2"></feather-icon>
          Add Addon
        </vs-button>
      </div>
      
      <!-- Filters -->
      <vs-row class="mb-4">
        <vs-col vs-w="4" vs-sm="6" vs-xs="12">
          <vs-input
            v-model="filters.name"
            class="w-full"
            label-placeholder="Search by name"
            @keyup.enter="loadAddons()"
          ></vs-input>
        </vs-col>
        <vs-col vs-w="3" vs-sm="6" vs-xs="12">
          <vs-select
            v-model="filters.type"
            class="w-full"
            placeholder="Type"
            @change="loadAddons()"
          >
            <vs-select-item value="" text="All Types"></vs-select-item>
            <vs-select-item value="backup" text="Backup"></vs-select-item>
            <vs-select-item value="snapshot" text="Snapshot"></vs-select-item>
            <vs-select-item value="monitoring" text="Monitoring"></vs-select-item>
            <vs-select-item value="security" text="Security"></vs-select-item>
          </vs-select>
        </vs-col>
        <vs-col vs-w="3" vs-sm="6" vs-xs="12">
          <vs-select
            v-model="filters.is_active"
            class="w-full"
            placeholder="Status"
            @change="loadAddons()"
          >
            <vs-select-item value="" text="All"></vs-select-item>
            <vs-select-item :value="1" text="Active"></vs-select-item>
            <vs-select-item :value="0" text="Inactive"></vs-select-item>
          </vs-select>
        </vs-col>
        <vs-col vs-w="2" vs-sm="12" vs-xs="12">
          <vs-button color="primary" class="w-full" @click="loadAddons()">
            <feather-icon icon="SearchIcon"></feather-icon>
          </vs-button>
        </vs-col>
      </vs-row>
      
      <!-- Addons Table -->
      <vs-table v-if="addons" :data="addons">
        <template slot="thead">
          <vs-th>ID</vs-th>
          <vs-th>Name</vs-th>
          <vs-th>Type</vs-th>
          <vs-th>Price/Month</vs-th>
          <vs-th>Description</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Actions</vs-th>
        </template>
        
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.id }}</vs-td>
            <vs-td>{{ tr.name }}</vs-td>
            <vs-td>
              <vs-chip :color="getTypeColor(tr.type)">
                {{ tr.type }}
              </vs-chip>
            </vs-td>
            <vs-td>${{ tr.price_per_month }}</vs-td>
            <vs-td>
              <small>{{ tr.description }}</small>
            </vs-td>
            <vs-td>
              <vs-chip :color="tr.is_active ? 'success' : 'danger'">
                {{ tr.is_active ? 'Active' : 'Inactive' }}
              </vs-chip>
            </vs-td>
            <vs-td>
              <vs-button
                size="small"
                color="primary"
                type="border"
                icon="edit"
                @click="editAddon(tr)"
              ></vs-button>
              <vs-button
                size="small"
                :color="tr.is_active ? 'warning' : 'success'"
                type="border"
                icon="power_settings_new"
                @click="toggleAddonStatus(tr.id)"
              ></vs-button>
              <vs-button
                size="small"
                color="danger"
                type="border"
                icon="delete"
                @click="deleteAddon(tr.id)"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    
    <!-- Create/Edit Dialog -->
    <vs-popup
      title="Addon Details"
      :active.sync="showDialog"
    >
      <div class="p-4">
        <vs-row>
          <vs-col vs-w="12">
            <vs-input
              v-model="formData.name"
              class="w-full mb-3"
              label="Addon Name"
            ></vs-input>
          </vs-col>
          
          <vs-col vs-w="6" vs-sm="12">
            <vs-select
              v-model="formData.type"
              class="w-full mb-3"
              label="Type"
            >
              <vs-select-item value="backup" text="Backup"></vs-select-item>
              <vs-select-item value="snapshot" text="Snapshot"></vs-select-item>
              <vs-select-item value="monitoring" text="Monitoring"></vs-select-item>
              <vs-select-item value="security" text="Security"></vs-select-item>
            </vs-select>
          </vs-col>
          
          <vs-col vs-w="6" vs-sm="12">
            <vs-input
              v-model.number="formData.price_per_month"
              class="w-full mb-3"
              label="Price per Month ($)"
              type="number"
              step="0.01"
            ></vs-input>
          </vs-col>
          
          <vs-col vs-w="12">
            <vs-textarea
              v-model="formData.description"
              class="w-full mb-3"
              label="Description"
            ></vs-textarea>
          </vs-col>
          
          <vs-col vs-w="12">
            <vs-textarea
              v-model="formData.features"
              class="w-full mb-3"
              label="Features (JSON format)"
              rows="4"
            ></vs-textarea>
            <small class="text-grey">Example: {"max_backups": 10, "retention_days": 30}</small>
          </vs-col>
          
          <vs-col vs-w="12">
            <vs-switch v-model="formData.is_active" class="mb-3">
              <span slot="on">Active</span>
              <span slot="off">Inactive</span>
            </vs-switch>
          </vs-col>
          
          <vs-col vs-w="12" class="flex justify-end">
            <vs-button
              color="danger"
              type="border"
              @click="showDialog = false"
              class="mr-2"
            >
              Cancel
            </vs-button>
            <vs-button
              color="primary"
              @click="saveAddon()"
            >
              {{ formData.id ? 'Update' : 'Create' }}
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'AddonsList',
  data() {
    return {
      addons: [],
      showDialog: false,
      filters: {
        name: '',
        type: '',
        is_active: ''
      },
      pagination: {
        current_page: 1,
        last_page: 1
      },
      formData: {
        id: null,
        name: '',
        type: 'backup',
        price_per_month: 5.00,
        description: '',
        features: '{}',
        is_active: true
      }
    }
  },
  mounted() {
    this.loadAddons()
  },
  methods: {
    async loadAddons() {
      try {
        const params = {
          ...this.filters
        }
        const response = await this.$http.get('/admin/haioflash/addons', { params })
        if (response && response.data && response.data.success) {
          this.addons = Array.isArray(response.data.data) ? response.data.data : []
        } else {
          this.addons = []
        }
      } catch (error) {
        this.addons = []
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to load addons',
          color: 'danger'
        })
        console.error(error)
      }
    },
    
    editAddon(addon) {
      this.formData = {
        ...addon,
        features: typeof addon.features === 'object' 
          ? JSON.stringify(addon.features, null, 2) 
          : addon.features
      }
      this.showDialog = true
    },
    
    async saveAddon() {
      try {
        // Validate JSON features
        let featuresObj = {}
        try {
          featuresObj = JSON.parse(this.formData.features)
        } catch (e) {
          this.$vs.notify({
            title: 'Error',
            text: 'Invalid JSON format in features field',
            color: 'danger'
          })
          return
        }
        
        const payload = {
          ...this.formData,
          features: featuresObj
        }
        
        if (this.formData.id) {
          await this.$http.put(`/admin/haioflash/addons/${this.formData.id}`, payload)
          this.$vs.notify({
            title: 'Success',
            text: 'Addon updated successfully',
            color: 'success'
          })
        } else {
          await this.$http.post('/admin/haioflash/addons', payload)
          this.$vs.notify({
            title: 'Success',
            text: 'Addon created successfully',
            color: 'success'
          })
        }
        this.showDialog = false
        this.resetForm()
        this.loadAddons()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to save addon',
          color: 'danger'
        })
        console.error(error)
      }
    },
    
    async toggleAddonStatus(id) {
      try {
        await this.$http.post(`/admin/haioflash/addons/${id}/toggle-active`)
        this.$vs.notify({
          title: 'Success',
          text: 'Addon status updated',
          color: 'success'
        })
        this.loadAddons()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to update addon status',
          color: 'danger'
        })
      }
    },
    
    async deleteAddon(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this addon?',
        accept: async () => {
          try {
            await this.$http.delete(`/admin/haioflash/addons/${id}`)
            this.$vs.notify({
              title: 'Success',
              text: 'Addon deleted successfully',
              color: 'success'
            })
            this.loadAddons()
          } catch (error) {
            this.$vs.notify({
              title: 'Error',
              text: 'Failed to delete addon',
              color: 'danger'
            })
          }
        }
      })
    },
    
    getTypeColor(type) {
      const colors = {
        'backup': 'primary',
        'snapshot': 'success',
        'monitoring': 'warning',
        'security': 'danger'
      }
      return colors[type] || 'dark'
    },
    
    resetForm() {
      this.formData = {
        id: null,
        name: '',
        type: 'backup',
        price_per_month: 5.00,
        description: '',
        features: '{}',
        is_active: true
      }
    }
  }
}
</script>
